<div class="component-viewer">
    <h1>Create Course</h1>
    <form [formGroup]="courseForm" (ngSubmit)="submit(courseForm)">
        <div fxLayout="column" fxLayoutGap="10">
            <mat-card  fxLayout="row wrap" fxLayoutGap="10">
                <mat-card-title>Demographics</mat-card-title>
                <mat-form-field>
                    <input matInput required name="name" id="name" placeholder="Name" type="text"
                        formControlName="name" />
                    <mat-error *ngIf="courseForm.get('name').errors?.required">Name is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('name').errors?.validationErrors">
                        {{ courseForm.get("name").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input required matInput name="shortName" id="shortName" placeholder="Short Name" type="text"
                        formControlName="shortName" />
                    <mat-error *ngIf="courseForm.get('shortName').errors?.required">Short Name is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('shortName').errors?.validationErrors">
                        {{ courseForm.get("shortName").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input required matInput name="address" id="address" placeholder="Address" type="text"
                        formControlName="address" />
                    <mat-error *ngIf="courseForm.get('address').errors?.required">Address is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('address').errors?.validationErrors">
                        {{ courseForm.get("address").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input required matInput name="city" id="city" placeholder="City" type="text"
                        formControlName="city" />
                    <mat-error *ngIf="courseForm.get('city').errors?.required">Cmail is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('city').errors?.validationErrors">
                        {{ courseForm.get("city").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input required matInput name="state" id="state" placeholder="State" type="text"
                        formControlName="state" />
                    <mat-error *ngIf="courseForm.get('state').errors?.required">State is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('state').errors?.validationErrors">
                        {{ courseForm.get("state").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input matInput name="zipCode" id="zipCode" placeholder="Zip Code" type="text"
                        formControlName="zipCode" />
                    <mat-error *ngIf="courseForm.get('zipCode').errors?.required">Zip Code is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('zipCode').errors?.validationErrors">
                        {{ courseForm.get("zipCode").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input matInput name="country" id="country" placeholder="Country" type="text"
                        formControlName="country" />
                    <mat-error *ngIf="courseForm.get('country').errors?.required">Country is required
                    </mat-error>
                    <mat-error *ngIf="courseForm.get('country').errors?.validationErrors">
                        {{ courseForm.get("country").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Is Private?</mat-label>
                    <mat-select name="isPrivate" id="isPrivate" formControlName="isPrivate">
                        <mat-option value="true">Yes</mat-option>
                        <mat-option value="false">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="courseForm.get('isPrivate').errors?.required">Is Private is
                        required</mat-error>
                    <mat-error *ngIf="courseForm.get('isPrivate').errors?.validationErrors">{{
                        courseForm.get("isPrivate").errors?.validationErrors}}</mat-error>
                </mat-form-field>
            </mat-card>
            <mat-card  fxLayout="column" fxLayoutGap="25">
                <div fxLayout="row" fxLayoutGap="10">
                    <mat-card-title>Teeboxes</mat-card-title>
                    <button mat-mini-fab (click)="addTeebox()"><mat-icon>add</mat-icon></button>
                </div>
                <div formArrayName="teeboxes">
                    <mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)">
                        <mat-tab *ngFor="let teebox of teeboxes.controls; let index = index"
                            [label]="teebox.get('teebox')?.value" [formGroupName]="index">
                            <div fxLayout="row wrap" fxLayoutGap="10">
                                <mat-form-field>
                                    <input matInput required name="teebox" id="teebox" placeholder="Teebox" type="text"
                                        formControlName="teebox" />
                                </mat-form-field>
                                <mat-form-field>
                                    <input matInput required name="yardage" id="yardage" placeholder="Yardage"
                                        type="text" formControlName="yardage" />
                                </mat-form-field>
                                <div fxLayout="row" fxLayoutGap="10" fxLayoutAlign=" center">
                                    <button mat-raised-button (click)="calculateYardage ">Calculate
                                        Yardage</button>
                                    <button mat-raised-button color="warn"
                                        [disabled]="teebox.get('teebox')?.length === 1"
                                        (click)="removeTeebox(index)">Delete Teebox</button>
                                </div>
                            </div>
                            <div formArrayName="holes" fxLayout="row">
                                <table class="table mat-table">
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">Hole</th>
                                        <ng-container
                                            *ngFor="let hole of teebox.get('holes')['controls']; let i = index">
                                            <td>{{hole.value.holeNumber}}</td>
                                        </ng-container>
                                    </tr>
                                    <tr class="mat-header-row">
                                        <td class="mat-header-cell">Handicap</td>
                                        <ng-container
                                            *ngFor="let hole of teebox.get('holes')['controls']; let i = index">
                                            <td>
                                                <div [formGroupName]="i">
                                                    <mat-form-field>
                                                        <input matInput required name="handicap" id="handicap"
                                                            type="number" formControlName="handicap" />
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr class="mat-header-row">
                                        <td class="mat-header-cell">Par</td>
                                        <ng-container
                                            *ngFor="let hole of teebox.get('holes')['controls']; let i = index">
                                            <td>
                                                <div [formGroupName]="i">
                                                    <mat-form-field>
                                                        <input matInput required name="par" id="par" type="number"
                                                            formControlName="par" />
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr class="mat-header-row">
                                        <td class="mat-header-cell">Yards</td>
                                        <ng-container
                                            *ngFor="let hole of teebox.get('holes')['controls']; let i = index">
                                            <td>
                                                <div [formGroupName]="i">
                                                    <mat-form-field>
                                                        <input matInput required name="yards" id="yards" type="number"
                                                            formControlName="yards" />
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </table>
                            </div>
                            <div fxLayout="row" fxLayoutGap="10">
                                <button mat-raised-button (click)="createTeebox(teebox)">Create Teebox</button>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-card>
            <mat-card  fxLayout="row" fxLayoutGap="10">
                <mat-card-actions>
                    <button mat-raised-button>Create Course</button>
                    <button mat-raised-button>Cancel</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </form>
</div>